export default {
  props: {},
  components: {},
  data: function data() {
    return {};
  },
  computed: {
    styles: function styles() {
      if (this.isApple || !this.isApp) {
        return {};
      }
      var statusBarHeight = window.cfmoto.statusBarHeight();
      return {
        paddingTop: "".concat(statusBarHeight)
      };
    }
  },
  methods: {},
  created: function created() {},
  mounted: function mounted() {},
  beforeUnmount: function beforeUnmount() {},
  watch: {}
};